import { ArrowBack } from '@mui/icons-material';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../assets/customIcons';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { useAppSelector } from '../../../store/hooks';
import JCIReturnPartDetails from './jciReturnPartDetailCard';
var InvoiceDetailsView = function (_ref) {
    var _customerInfo$data, _customerInfo$data2, _customerInfo$data3, _customerInfo$data4, _customerInfo$data5;
    var onClose = _ref.onClose, data = _ref.data;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _a = useAppSelector(function (state) { return state.crud; }), insallbase = _a.insallbase, customerInfo = _a.customerInfo, viewInvoiceDetails = _a.viewInvoiceDetails;
    var partElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            rowSpacing: 2,
            columnSpacing: 2,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    sx: {
                        bgcolor: 'secondary.50',
                        borderRadius: '8px',
                        border: '1px solid ',
                        borderColor: 'secondary.200'
                    },
                    padding: '8px 12px ',
                    gap: '4px',
                    display: 'flex',
                    flexDirection: 'column',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'UnitOfMeasurementName',
                            label: 'UOM: ',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            value: "23"
                            // setFormState: (formValues) => {
                            //     console.log('form values ', formValues)
                            //     return formValues
                            // }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ProductName',
                            label: 'Issued Location:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Previous return qty:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Available qty for return:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Return qty:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Purchase cost (₹):',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Total cost (₹):',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }]
                }]
        }];
    var invoiceDetails = [isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            mt: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: '',
                    columnSize: 12,
                    flexDirection: "row",
                    // pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            onClick: function (e) {
                                onClose();
                            },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            flexDirection: 'column',
                            columnSize: true,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: "Invoice details -INV2345678998",
                                    // label: 'Invoice details - INV2345678998',
                                    fontWeight: 'strong',
                                    fontSize: isMobile ? 'lg' : 'xxl',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: ' ',
                                    value: 'Paid part invoice',
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: true
                                }]
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: '12px',
                                width: '12px'
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            }
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 12,
                    item: false,
                    justifyContent: "end",
                    // columns: 0,
                    pt: '16px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'View JC lifecycle',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'primary',
                            onClick: function () { return alert("Click to View JC lifecycle"); }
                        }]
                }]
        } : {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            mt: 2,
            // minWidth: '100%',
            bgcolor: 'overlay.white',
            flexDirection: 'row',
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: '',
                    columnSize: true,
                    display: "flex",
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            flexDirection: 'column',
                            columnSize: 10,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: "Invoice details -INV2345678998",
                                    fontWeight: 'strong',
                                    fontSize: 'xxl',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: ' ',
                                    value: 'Paid part invoice',
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 0
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    alignItems: 'center',
                    columns: 0,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'View JC lifecycle',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'primary',
                            onClick: function () { return alert("Click to View JC lifecycle"); }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: '12px',
                                width: '12px'
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            },
                            sx: {
                            // padding: '12px'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: 'invoiceDetails',
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Accordian,
                    name: 'jobcardInvoiceDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'job card invoice details',
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'job card invoice details',
                                    label: 'job card invoice details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'JobCardInvoicedNo',
                                            label: 'Job card invoice number:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'InvoiceDate',
                                            label: 'invoice date:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'JobCardNo',
                                            label: 'Job card number::',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Posting type:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'ServiceTypeName',
                                            label: 'Service type:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Service advisor :',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'CampaignName',
                                            label: 'Campaign: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Delay reason:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'InvoiceSummary ',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Invoice summary ',
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Invoice summary',
                                    label: 'Invoice summary',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'CampaignName:',
                                            label: 'Basic amount: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'TotalDiscount',
                                            label: 'Discount: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            //color: 'red'
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'OtherCharges',
                                            label: 'Charges: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Taxable amount: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'CGSTAmount',
                                            label: 'CGST',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'SGSTAmount',
                                            label: 'SGST',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'IGStAmount',
                                            label: 'IGST: ',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'GrandTotal',
                                            label: 'Grand total:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'PaymentDetail',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Payment detail',
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'JC invoice return details',
                                    label: 'JC invoice return details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    labelTypographyProps: {
                                        fontWeight: 'strong'
                                    },
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'PaidAmount',
                                            label: 'Paid amount:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Outstanding amount:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PaymentMode',
                                            label: 'Payment mode:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Payment method:',
                                            label: 'Payment method:',
                                            value: '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Payment date:',
                                            label: 'Payment date:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'CustomerDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Customer details',
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Customer details',
                                    label: 'Customer details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'Name',
                                            label: 'Name',
                                            value: (customerInfo === null || customerInfo === void 0 || (_customerInfo$data = customerInfo.data) === null || _customerInfo$data === void 0 || (_customerInfo$data = _customerInfo$data.Person) === null || _customerInfo$data === void 0 ? void 0 : _customerInfo$data.GivenName) + '' + (customerInfo === null || customerInfo === void 0 || (_customerInfo$data2 = customerInfo.data) === null || _customerInfo$data2 === void 0 || (_customerInfo$data2 = _customerInfo$data2.Person) === null || _customerInfo$data2 === void 0 ? void 0 : _customerInfo$data2.FamilyName),
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Mobile no:',
                                            label: 'Mobile no:',
                                            value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data3 = customerInfo.data) === null || _customerInfo$data3 === void 0 ? void 0 : _customerInfo$data3.MobileNumber,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Address :',
                                            label: 'Address :',
                                            value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data4 = customerInfo.data) === null || _customerInfo$data4 === void 0 || (_customerInfo$data4 = _customerInfo$data4.Address[0]) === null || _customerInfo$data4 === void 0 ? void 0 : _customerInfo$data4.Address1,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Mail',
                                            label: 'Mail',
                                            value: customerInfo === null || customerInfo === void 0 || (_customerInfo$data5 = customerInfo.data) === null || _customerInfo$data5 === void 0 ? void 0 : _customerInfo$data5.Email,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'VehicleDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Vehicle details',
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'VehicleDetails',
                                    label: 'Vehicle details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            label: 'Job card invoice number::',
                                            value: 'IC2345678990987654',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '14 Dec, 2024',
                                            label: 'invoice date:',
                                            value: '14 Dec, 2024. ',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Job card number::',
                                            label: 'Job card number::',
                                            value: 'JC2345678990987654',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Posting type:',
                                            label: 'Posting type:',
                                            value: 'Paid',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Service type:',
                                            label: 'Service type:',
                                            value: 'Paid periodic service',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Service advisor :',
                                            label: 'Service advisor :',
                                            value: 'Rajesh',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Campaign:',
                                            label: 'Campaign: ',
                                            value: 'Bajaj dominar diwali dhamaka',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Delay reason:',
                                            label: 'Delay reason:',
                                            value: 'Delay reason:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'InsuranceDetails',
                    columnSize: 12,
                    value: false,
                    sx: {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Insurance details',
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'header',
                            columnSize: 12,
                            sx: {
                                margin: '12px 0px 12px 12px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Insurance details',
                                    label: 'Insurance details',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    spacing: 0,
                                    padding: '8px 0px 8px 12px ',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'Insurer name:',
                                            label: 'Insurer name:',
                                            value: 'ICICI Lombard',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Policy date:',
                                            label: 'Policy date:',
                                            value: '12 Dec, 2024',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Policy type:',
                                            label: 'Policy type:',
                                            value: 'Comprehensive',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Policy no:',
                                            label: 'Policy no:',
                                            value: '2345678909876598765',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Insurance claim number:',
                                            label: 'Date of sale:',
                                            value: '2345678765',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }]
                        }]
                }]
        } :
            // {
            //     type: FormItemTypes.ContainerItem,
            //     name: 'header',
            //     columnSize: 12,
            //     spacing: 2.5,
            //     // bgcolor: secondary[50],
            //     elements: [
            //         {
            //             type: FormItemTypes.Typography,
            //             name: 'jobcardInvoiceDetails',
            //             label: 'job card invoice details',
            //             value: '',
            //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //             fontWeight: 'medium',
            //             fontSize: 'sm',
            //             columnSize: 6,
            //         },
            //         {
            //             type: FormItemTypes.Typography,
            //             name: 'Invoice summary ',
            //             label: 'Invoice summary ',
            //             value: '',
            //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //             fontWeight: 'medium',
            //             fontSize: 'sm',
            //             columnSize: 6,
            //         },
            //         {
            //             type: FormItemTypes.CardComponent,
            //             name: 'header',
            //             columnSize: 6,
            //             elements: [
            //                 {
            //                     type: FormItemTypes.ContainerItem,
            //                     name: 'JC invoice return details',
            //                     label: 'JC invoice return details',
            //                     display: 'flex',
            //                     justifyContent: 'space-between',
            //                     columnSize: 12,
            //                     spacing: 0,
            //                     padding: '8px 0px 0px 12px ',
            //                     elements: [
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'JobCardInvoicedNo',
            //                             label: 'Job card invoice number:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'InvoiceDate',
            //                             label: 'invoice date:',
            //                             value: null,
            //                             valueGetter: (formValues, field) => formValues?.[field?.name ?? ''] ? dayjs(formValues?.[field?.name ?? '']).format('DD MMM, YYYY') : '-',
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'JobCardNo',
            //                             label: 'Job card number::',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: '',
            //                             label: 'Posting type:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'ServiceTypeName',
            //                             label: 'Service type:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: '',
            //                             label: 'Service advisor :',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'CampaignName',
            //                             label: 'Campaign: ',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: '',
            //                             label: 'Delay reason:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                     ]
            //                 }
            //             ],
            //         },
            //         {
            //             type: FormItemTypes.CardComponent,
            //             name: 'header',
            //             columnSize: 6,
            //             elements: [
            //                 {
            //                     type: FormItemTypes.ContainerItem,
            //                     name: '',
            //                     label: 'Invoice summary',
            //                     display: 'flex',
            //                     justifyContent: 'space-between',
            //                     columnSize: 12,
            //                     spacing: 0,
            //                     padding: '8px 0px 0px 12px ',
            //                     elements: [
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'CampaignName:',
            //                             label: 'Basic amount: ',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'TotalDiscount',
            //                             label: 'Discount: ',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1, color: 'red' },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'OtherCharges',
            //                             label: 'Charges: ',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: '',
            //                             label: 'Taxable amount: ',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'CGSTAmount',
            //                             label: 'CGST',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'SGSTAmount',
            //                             label: 'SGST',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'IGStAmount',
            //                             label: 'IGST: ',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'GrandTotal',
            //                             label: 'Grand total:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                     ]
            //                 }
            //             ],
            //         },
            //         {
            //             type: FormItemTypes.Typography,
            //             name: '',
            //             label: 'Return amount details',
            //             value: '',
            //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //             fontWeight: 'medium',
            //             fontSize: 'sm',
            //             columnSize: 6,
            //         },
            //         {
            //             type: FormItemTypes.Typography,
            //             name: 'Customer details',
            //             label: 'Customer details',
            //             value: '',
            //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //             fontWeight: 'medium',
            //             fontSize: 'sm',
            //             columnSize: 6,
            //         },
            //         {
            //             type: FormItemTypes.CardComponent,
            //             name: 'header',
            //             columnSize: 6,
            //             elements: [
            //                 {
            //                     type: FormItemTypes.ContainerItem,
            //                     name: 'JC invoice return details',
            //                     label: 'JC invoice return details',
            //                     display: 'flex',
            //                     justifyContent: 'space-between',
            //                     columnSize: 12,
            //                     spacing: 0,
            //                     padding: '8px 0px 0px 12px ',
            //                     elements: [
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'ReturnAmount',
            //                             label: 'Return amount:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'PaymentMode',
            //                             label: 'Payment mode:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'Payment method:',
            //                             label: 'Payment method:',
            //                             value: '-',
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'Payment date:',
            //                             label: 'Payment date:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                     ]
            //                 }
            //             ],
            //         },
            //         {
            //             type: FormItemTypes.CardComponent,
            //             name: 'header',
            //             columnSize: 6,
            //             elements: [
            //                 {
            //                     type: FormItemTypes.ContainerItem,
            //                     name: 'Customer details',
            //                     label: 'Customer details',
            //                     display: 'flex',
            //                     justifyContent: 'space-between',
            //                     columnSize: 12,
            //                     spacing: 0,
            //                     padding: '8px 0px 0px 12px ',
            //                     elements: [
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'Name',
            //                             label: 'Name',
            //                             value: customerInfo?.data?.Person?.GivenName + '' + customerInfo?.data?.Person?.FamilyName,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'Mobile no:',
            //                             label: 'Mobile no:',
            //                             value: customerInfo?.data?.MobileNumber,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'Address :',
            //                             label: 'Address :',
            //                             value: customerInfo?.data?.Address[0]?.Address1,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'Mail',
            //                             label: 'Mail',
            //                             value: customerInfo?.data?.Email,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                     ]
            //                 }
            //             ],
            //         },
            //         {
            //             type: FormItemTypes.Typography,
            //             name: 'Vehicle details',
            //             label: 'Vehicle details',
            //             value: '',
            //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //             fontWeight: 'medium',
            //             fontSize: 'sm',
            //             columnSize: 12,
            //         },
            //         {
            //             type: FormItemTypes.CardComponent,
            //             name: 'header',
            //             columnSize: 6,
            //             elements: [
            //                 {
            //                     type: FormItemTypes.ContainerItem,
            //                     name: 'Vehicle details',
            //                     label: 'Vehicle details',
            //                     display: 'flex',
            //                     justifyContent: 'space-between',
            //                     columnSize: 12,
            //                     spacing: 0,
            //                     padding: '8px 0px 0px 12px ',
            //                     elements: [
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'RegistrationNo',
            //                             label: 'Registration no:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'ProductName',
            //                             label: 'Model',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'EngineNo',
            //                             label: 'Engine no:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'VinNo',
            //                             label: 'Chassis no.:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                         {
            //                             type: FormItemTypes.Typography,
            //                             name: 'SalesInvoiceDate',
            //                             label: 'Date of sale:',
            //                             value: null,
            //                             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
            //                             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
            //                             fontWeight: 'medium',
            //                             fontSize: 'sm',
            //                             columnSize: 12,
            //                         },
            //                     ]
            //                 }
            //             ],
            //         },
            //     ]
            // },
            {
                type: FormItemTypes.ContainerItem,
                name: 'header',
                columnSize: 12,
                spacing: 2.5,
                // bgcolor: secondary[50],
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'JC invoice return details',
                        value: 'JC invoice return details',
                        // containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                        // labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                        fontWeight: 'strong',
                        fontSize: 'base',
                        columnSize: 6
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Return invoice summary',
                        value: 'Return invoice summary',
                        // containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                        // labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'strong', fontSize: 'sm' },
                        fontWeight: 'strong',
                        fontSize: 'base',
                        columnSize: 6
                    }, {
                        type: FormItemTypes.CardComponent,
                        name: 'header',
                        columnSize: 6,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: 'JC invoice return details',
                                label: 'JC invoice return details',
                                display: 'flex',
                                justifyContent: 'space-between',
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: 'Job card invoice number:',
                                        label: 'Job card invoice number::',
                                        value: 'IC2345678990987654',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Job card invoice return No.:',
                                        label: 'Job card invoice return No.::',
                                        value: 'IC2345678990987654.',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Job card invoice return No. date:',
                                        label: 'Job card invoice return No. date::',
                                        value: 'Diwali Dhamaka.',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'invoice date:',
                                        label: 'invoice date::',
                                        value: 'invoice date:.',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Job card number::',
                                        label: 'Job card number::',
                                        value: 'JC2345678990987654',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Posting type:',
                                        label: 'Posting type:',
                                        value: 'Paid',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Service type:',
                                        label: 'Service type:',
                                        value: 'Paid periodic service',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Service advisor :',
                                        label: 'Service advisor :',
                                        value: 'Rajesh',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.CardComponent,
                        name: 'header',
                        columnSize: 6,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: 'Return invoice summary',
                                label: 'Return invoice summary',
                                display: 'flex',
                                justifyContent: 'space-between',
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: 'Basic amount:',
                                        label: 'Basic amount:',
                                        // value: '14 Dec, 2024 - 4:00 PM',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Charges:',
                                        label: 'Charges:',
                                        // value: 'BM Rushikesh.',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Taxable amount:',
                                        label: 'Taxable amount:',
                                        value: 'Diwali Dhamaka.',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'CGST:',
                                        label: 'CGST',
                                        value: '23232',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'SGST',
                                        label: 'SGST',
                                        value: '111111',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'IGST:',
                                        label: 'IGST: ',
                                        value: '1212',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Grand total::',
                                        label: 'Grand total:',
                                        value: '1212',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Return amount details',
                        value: 'Return amount details',
                        // containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                        // labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                        fontWeight: 'strong',
                        fontSize: 'base',
                        columnSize: 6
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Customer details',
                        value: 'Customer details',
                        // containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                        // labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                        fontWeight: 'strong',
                        fontSize: 'base',
                        columnSize: 6
                    }, {
                        type: FormItemTypes.CardComponent,
                        name: 'header',
                        columnSize: 6,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: 'JC invoice return details',
                                label: 'JC invoice return details',
                                display: 'flex',
                                justifyContent: 'space-between',
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: 'Return amount:',
                                        label: 'Return amount:',
                                        value: '12122',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Payment mode:',
                                        label: 'Payment mode:',
                                        value: 'UPI.',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Payment method:',
                                        label: 'Payment method:',
                                        value: 'Cash',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Return amount date:',
                                        label: 'Return amount date:',
                                        value: '111',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.CardComponent,
                        name: 'header',
                        columnSize: 6,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: 'Customer details',
                                label: 'Customer details',
                                display: 'flex',
                                justifyContent: 'space-between',
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: 'Name',
                                        label: 'Name',
                                        // value: '14 Dec, 2024 - 4:00 PM',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Mobile no:',
                                        label: 'Mobile no:',
                                        value: '3343434234',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Address :',
                                        label: 'Address :',
                                        value: 'Ganga Home',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Mail',
                                        label: 'Mail',
                                        value: 'Address@gmail.com',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Vehicle details',
                        value: 'Vehicle details',
                        // containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                        // labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                        fontWeight: 'strong',
                        fontSize: 'base',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.CardComponent,
                        name: 'header',
                        columnSize: 6,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: 'Vehicle details',
                                label: 'Vehicle details',
                                display: 'flex',
                                justifyContent: 'space-between',
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: 'Registration no:',
                                        label: 'Registration no:',
                                        value: 'MH12PY0987',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Registration no:',
                                        label: 'Model',
                                        value: 'MH12PY0987',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Engine no.:',
                                        label: 'Engine no:',
                                        value: 'AZXWME51553',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Chassis no.:',
                                        label: 'Chassis no.:',
                                        value: 'MD2DDDZZZMWL36200',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: 'Date of sale:',
                                        label: 'Date of sale:',
                                        value: '27-01-2023',
                                        containerProps: {
                                            display: 'inline-flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'baseline',
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }, isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            elements: [
                // {
                //     type: FormItemTypes.ContainerItem,
                //     name: '',
                //     columnSize: 12,
                //     spacing: 0,
                //     width: 'auto',
                //     sx: {
                //         overflowX: 'auto',
                //         overflowY: 'visible',
                //         flexWrap: 'nowrap',
                //         width: '100%',
                //         scrollbarWidth: 'none'
                //     },
                //     position: 'static',
                //     elements: [
                //         {
                //             type: FormItemTypes.ContainerItem,
                //             name: '',
                //             columnSize: 0,
                //             bgcolor: 'secondary.100',
                //             padding: '6px',
                //             borderRadius: '12px',
                //             spacing: 0,
                //             width: '480px',
                //             border: '1px solid',
                //             borderColor: 'secondary.200',
                //             height: '54px',
                //             wrap: 'nowrap',
                //             columnGap: 2,
                //             elements: [
                //                 {
                //                     type: FormItemTypes.Button,
                //                     label: '',
                //                     name: 'Paid',
                //                     columnSize: 0,
                //                     children: [
                //                         'Paid',
                //                         <Chip
                //                             variant='filled'
                //                             size='small'
                //                             color='secondary'
                //                             sx={{
                //                                 fontWeight: 'medium',
                //                                 color: 'text.primary',
                //                             }}
                //                             label='23,600.00'
                //                         />
                //                     ],
                //                     variant: 'text',
                //                     color: 'secondary',
                //                     size: 'small',
                //                     setFormState: async () => {
                //                         const FilterPaidParts = viewInvoiceDetails?.data?.InvoiceDetails?.Parts?.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'paid')
                //                         const FilterPaidLabour = viewInvoiceDetails?.data?.InvoiceDetails?.Labours.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'paid')
                //                         return {
                //                             Parts: FilterPaidParts,
                //                             Labours: FilterPaidLabour,
                //                             SelectedButton: 'paid'
                //                         }
                //                     },
                //                     setFieldProps: (state: any) => (
                //                         {
                //                             type: FormItemTypes.Button,
                //                             variant: state?.SelectedButton === 'paid' ? 'outlined' : 'text',
                //                             color: 'secondary',
                //                             sx: {
                //                                 fontWeight: 'strong',
                //                                 color: state?.SelectedButton === 'paid' ? 'text.primary' : undefined,
                //                                 bgcolor: state?.SelectedButton === 'paid' ? 'white' : "secondary.100",
                //                             },
                //                         }),
                //                 },
                //                 {
                //                     type: FormItemTypes.Button,
                //                     label: '',
                //                     name: 'Expense',
                //                     columnSize: 0,
                //                     children: [
                //                         'Expense',
                //                         <Chip
                //                             variant='filled'
                //                             size='small'
                //                             color='secondary'
                //                             sx={{
                //                                 fontWeight: 'medium',
                //                                 color: 'text.primary',
                //                             }}
                //                             label='25,000.00'
                //                         />
                //                     ],
                //                     variant: 'text',
                //                     color: 'secondary',
                //                     size: 'small',
                //                     fullWidth: true,
                //                     setFormState: async () => {
                //                         const FilterExpenseParts = viewInvoiceDetails?.data?.InvoiceDetails?.Parts?.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'expenses')
                //                         const FilterExpenseLabour = viewInvoiceDetails?.data?.InvoiceDetails?.Labours.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'expenses')
                //                         return {
                //                             Parts: FilterExpenseParts,
                //                             Labours: FilterExpenseLabour,
                //                             SelectedButton: 'expense'
                //                         }
                //                     },
                //                     setFieldProps: (state: any) => (
                //                         {
                //                             type: FormItemTypes.Button,
                //                             variant: state?.SelectedButton === 'expense' ? 'outlined' : 'text',
                //                             color: 'secondary',
                //                             sx: {
                //                                 fontWeight: 'strong',
                //                                 color: state?.SelectedButton === 'expense' ? 'text.primary' : undefined,
                //                                 bgcolor: state?.SelectedButton === 'expense' ? 'white' : "secondary.100",
                //                             },
                //                         }),
                //                 },
                //                 {
                //                     type: FormItemTypes.Button,
                //                     label: '',
                //                     name: 'Claims',
                //                     columnSize: 0,
                //                     children: [
                //                         'Claims',
                //                         <Chip
                //                             variant='filled'
                //                             size='small'
                //                             color='secondary'
                //                             sx={{
                //                                 fontWeight: 'medium',
                //                                 color: 'text.primary',
                //                             }}
                //                             label='28,000.00'
                //                         />
                //                     ],
                //                     variant: 'text',
                //                     color: 'secondary',
                //                     size: 'small',
                //                     fullWidth: true,
                //                     setFormState: async () => {
                //                         const FilterClaimsParts = viewInvoiceDetails?.data?.InvoiceDetails?.Parts?.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'generate claims')
                //                         const FilterClaimsLabour = viewInvoiceDetails?.data?.InvoiceDetails?.Labours.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'generate claims')
                //                         return {
                //                             Parts: FilterClaimsParts,
                //                             Labours: FilterClaimsLabour,
                //                             SelectedButton: 'claims'
                //                         }
                //                     },
                //                     setFieldProps: (state: any) => (
                //                         {
                //                             type: FormItemTypes.Button,
                //                             variant: state?.SelectedButton === 'claims' ? 'outlined' : 'text',
                //                             color: 'secondary',
                //                             sx: {
                //                                 fontWeight: 'strong',
                //                                 color: state?.SelectedButton === 'claims' ? 'text.primary' : undefined,
                //                                 bgcolor: state?.SelectedButton === 'claims' ? 'white' : "secondary.100",
                //                             },
                //                         }),
                //                 },
                //             ],
                //         },
                //     ]
                // },
                {
                    type: FormItemTypes.Accordian,
                    name: 'part',
                    label: '',
                    value: null,
                    sx: {
                        bgcolor: 'transparent',
                        border: 'none'
                    },
                    detailPanelProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            padding: 0
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: 'partDetail',
                            label: '',
                            value: null,
                            children: 'Parts',
                            columnSize: 0,
                            fontWeight: 'strong',
                            fontSize: 'lg'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'Count',
                            columnSize: 0,
                            size: 'small',
                            variant: 'outlined',
                            color: 'info',
                            sx: {
                                ml: '8px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$Parts;
                                return (formValues === null || formValues === void 0 || (_formValues$Parts = formValues.Parts) === null || _formValues$Parts === void 0 ? void 0 : _formValues$Parts.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$Parts$len, _formValues$Parts2;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$Parts$len = formValues === null || formValues === void 0 || (_formValues$Parts2 = formValues.Parts) === null || _formValues$Parts2 === void 0 ? void 0 : _formValues$Parts2.length) !== null && _formValues$Parts$len !== void 0 ? _formValues$Parts$len : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.Accordian,
                            name: 'part',
                            label: '',
                            value: null,
                            sx: {
                                borderRadius: '12px'
                            },
                            summaryProps: {
                                sx: {
                                    // paddingInline: '12px',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }
                            },
                            summary: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'partDetail',
                                            label: '',
                                            value: null,
                                            children: 'Parts',
                                            columnSize: 0,
                                            variant: "h5"
                                        }, {
                                            type: FormItemTypes.Chip,
                                            name: 'count',
                                            color: 'info',
                                            sx: {
                                                ml: '4px'
                                            },
                                            value: "4"
                                            // valueGetter: (formValues, field) => {
                                            //     return formValues?.partDetails?.length || 0;
                                            // },
                                            // setFieldProps(formValues, currValue) {
                                            //     return {
                                            //         type: FormItemTypes.Chip,
                                            //         sx: {
                                            //             display: (formValues?.partDetails?.length ?? 0) > 0 ? 'inline-flex' : 'none',
                                            //             ml: '4px'
                                            //         }
                                            //     }
                                            // },
                                        }]
                                }],
                            elements: [{
                                    type: FormItemTypes.SearchSelect,
                                    name: 'Parts',
                                    // getListData: getPartList,
                                    apiKey: 'partList',
                                    multiple: true,
                                    renderTags: function () { return null; },
                                    clearText: 'Clear Selected Parts',
                                    columnSize: true,
                                    placeholder: 'Enter part name code',
                                    displayExpr: 'Name',
                                    valueExpr: 'id'
                                    // setFormState: (state, value) => {
                                    //     if (!value?.length) return {};
                                    //     return {
                                    //         partDetails: [
                                    //             ...value.slice(0, -1),
                                    //             {
                                    //                 ChildName: value.at(-1)?.Name,
                                    //                 ChildId: value.at(-1)?.ProductId,
                                    //                 id: value.at(-1)?.ProductId,
                                    //                 ChildCode: value.at(-1)?.SkuCode
                                    //             }
                                    //         ]
                                    //     };
                                    // },
                                    // valueGetter: (state) => state.partDetails,
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'More',
                                    // children: <MoreVert />,
                                    size: 'small',
                                    variant: 'outlined',
                                    color: 'secondary',
                                    sx: {
                                        p: '7px'
                                    },
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    sx: {
                                        color: 'text.secondary'
                                    },
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.List,
                                    name: 'partsDetailsList',
                                    // variant: 'comfortable',
                                    columnSize: 12,
                                    value: [{
                                            "_id": "33c5b045-5480-47ff-9111-c5e8aad39b57",
                                            "id": "33c5b045-5480-47ff-9111-c5e8aad39b57",
                                            "SchemaId": "0ffdbd01-218f-4681-92fd-cde59effb50f",
                                            "PartitionKey": "177881c0-4f30-41f0-a949-a7df2fa63d8a",
                                            "CreatedOn": "2024-09-30T10:11:32.914Z",
                                            "CreatedBy": "1d5f87ed-324d-4456-a230-30b27bfd5c78",
                                            "UpdatedOn": "2025-03-06T09:40:35.690Z",
                                            "UpdatedBy": "16bbd637-2451-4061-9e70-4a03de187baf",
                                            "_type": "JobCardDetail",
                                            "_ts": "2025-03-06T09:40:35.690Z",
                                            "JobCardDetailId": "33c5b045-5480-47ff-9111-c5e8aad39b57",
                                            "JobCardId": "ba742b49-31ff-4a45-aabe-4318dc7ea3eb",
                                            "EntityId": "e8672fd9-2b81-4070-bc5f-72913cc6dd45",
                                            "ChildId": "303d1b68-3b89-4f31-95ed-ebd368e692a9",
                                            "UnitOfMeasurementId": "c4c9e92c-72d7-4564-8abd-1e6cebb76809",
                                            "StatusId": "0e2ab118-7ce9-4727-a5f6-8453d0d5ff45",
                                            "JobCardServiceGroup": 1,
                                            "Quantity": 1,
                                            "IsActive": true,
                                            "IsDeleted": false,
                                            "IsOutsideLabour": false,
                                            "ServiceGroupId": "1ab0536e-cbda-4f88-b46f-8d6e674cbfa7",
                                            "Price": null,
                                            "ServiceTypeId": "21dacac4-c139-4da9-98e0-f916d3ad4c95",
                                            "ServiceStationTypeId": null,
                                            "ServiceStartDateTime": null,
                                            "ServiceEndDateTime": null,
                                            "ExpectedStartDateTIme": null,
                                            "ExpectedEndDateTIme": null,
                                            "ReworkStartDateTime": null,
                                            "ReworkEndDateTime": null,
                                            "ChildCode": "DY161210",
                                            "ChildName": "CABLE CLUTCH",
                                            "AllocatedQty": 0,
                                            "IsAutoFill": false,
                                            "AutofillType": null,
                                            "HSNSACId": null,
                                            "Description": null,
                                            "ApprovalStatusId": null,
                                            "CWIApprovalId": null,
                                            "CWIRejectReasonId": null,
                                            "ReasonForPendencyId": null,
                                            "RMApprovalDate": null,
                                            "RMServiceApprovalStatusId": null,
                                            "RMServiceRemarks": null,
                                            "Remarks": null,
                                            "ASMActivityDate": null,
                                            "UBApprovedASMUserId": null,
                                            "UBASMApprovedDateTime": null,
                                            "IsASMApproved": null,
                                            "DefectId": null,
                                            "SOHPercentage": null,
                                            "IsPaidPartWarranty": null,
                                            "IsMoreThanThreeTimesWarranty": null,
                                            "SpareIssueStatusId": null,
                                            "IsEngine": null,
                                            "IsBS6": null,
                                            "BatterySerialNumber": null,
                                            "Source": null,
                                            "OldComponentSerialNumber": null,
                                            "ICC_ID": null,
                                            "IMEI_ID": null,
                                            "ReEstimateStatusId": null,
                                            "IsGRNDone": null,
                                            "GRNDoneFromUtility": null,
                                            "IssuedQuantity": 0,
                                            "AvailableQuantity": 0,
                                            "OnHandQuantity": 0,
                                            "PendingQuantity": 0,
                                            "NotIssuedQuantity": null,
                                            "ReturnedQuantity": null,
                                            "CancelQuantity": null,
                                            "ReworkId": null,
                                            "OutsideSupplierId": null,
                                            "OutsideWorkPurchaseOrderId": null,
                                            "OutsideRemarks": null,
                                            "ServiceTypeName": "Fourth Free Service-3W",
                                            "UnitOfMeasurementName": "EACH",
                                            "ProductName": "CABLE CLUTCH",
                                            "ChildSystemName": "Product",
                                            "SKUCode": "DY161210",
                                            "RequestedQuantity": 1,
                                            "IssueQuantity": 0,
                                            "DefaultInventoryTrackingType": "Serialized",
                                            "HSNSACCode": "87141090",
                                            "LocationDetails": [{
                                                    "ProductId": "303d1b68-3b89-4f31-95ed-ebd368e692a9",
                                                    "LocationId": "73656d71-80a8-4b54-815e-00e4b600532b",
                                                    "QuantityOnPurchaseOrder": 0,
                                                    "QuantityOnTransit": 0,
                                                    "QuantityAvailable": 0,
                                                    "WarehouseId": "66aac928-8855-4421-83d2-27fd79e2cfd2",
                                                    "OnHandQuantity": 0,
                                                    "ProjectedQuantity": 0,
                                                    "id": "73656d71-80a8-4b54-815e-00e4b600532b",
                                                    "LocationName": "Default",
                                                    "WarehouseName": "Default",
                                                    "DamageQuantity": 0,
                                                    "LocationCode": "LCN-0000000000069"
                                                }, {
                                                    "ProductId": "303d1b68-3b89-4f31-95ed-ebd368e692a9",
                                                    "LocationId": "5436b80d-c5a9-4370-a0c3-8179348122d8",
                                                    "QuantityOnPurchaseOrder": 0,
                                                    "QuantityOnTransit": 0,
                                                    "QuantityAvailable": 0,
                                                    "WarehouseId": "2a00e105-02d6-4674-8b5c-841088ed286f",
                                                    "OnHandQuantity": 0,
                                                    "ProjectedQuantity": 0,
                                                    "id": "5436b80d-c5a9-4370-a0c3-8179348122d8",
                                                    "LocationName": "Default",
                                                    "WarehouseName": "Default2",
                                                    "LocationCode": "LCN-0000000000069"
                                                }],
                                            "ProjectedQuantity": 0,
                                            "Code": "DY161210",
                                            "RatioBilling": [],
                                            "JobCardBillingRatio": [],
                                            "PriceDetail": {
                                                "Price": 0,
                                                "Type": "Base",
                                                "IsEditable": true,
                                                "IsConfigured": false,
                                                "Rate": 0
                                            },
                                            "HSNCode": "87141090"
                                        }],
                                    // apiKey:'partDetailsGet',
                                    containerProps: {
                                        sx: {
                                            mb: '16px'
                                        }
                                    },
                                    // apiKey: SpareIssueReturnKeys.PartDetails,
                                    columns: [{
                                            field: 'Part',
                                            flex: 1,
                                            renderCell: function (_ref2) {
                                                var row = _ref2.row;
                                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                                    variant: "h3"
                                                }, row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                                    variant: "h6",
                                                    color: "secondary"
                                                }, row.ChildCode ? '#' + row.ChildCode : ''));
                                            }
                                        }],
                                    elements: partElements
                                }],
                            detailPanelProps: {
                                sx: {
                                    paddingInline: '12px'
                                }
                            },
                            columnSize: 12
                        }],
                    columnSize: 12
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'labour',
                    label: '',
                    value: null,
                    sx: {
                        bgcolor: 'transparent',
                        borderLeft: 'none',
                        borderRight: 'none'
                    },
                    summaryProps: {
                        sx: {
                            padding: 0,
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex'
                        }
                    },
                    detailPanelProps: {
                        spacing: 0
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: 'labourDetail',
                            label: '',
                            value: null,
                            children: 'Labour',
                            columnSize: 0,
                            fontWeight: 'strong',
                            fontSize: 'lg'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'Count',
                            columnSize: 0,
                            size: 'small',
                            variant: 'outlined',
                            color: 'info',
                            sx: {
                                ml: '8px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$Labours;
                                return (formValues === null || formValues === void 0 || (_formValues$Labours = formValues.Labours) === null || _formValues$Labours === void 0 ? void 0 : _formValues$Labours.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$Labours$l, _formValues$Labours2;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$Labours$l = formValues === null || formValues === void 0 || (_formValues$Labours2 = formValues.Labours) === null || _formValues$Labours2 === void 0 ? void 0 : _formValues$Labours2.length) !== null && _formValues$Labours$l !== void 0 ? _formValues$Labours$l : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'Labours',
                            columnSize: 12,
                            value: null,
                            disableCheckboxSelection: true,
                            columns: [{
                                    field: 'Labour',
                                    flex: 1,
                                    renderCell: function (params) {
                                        var _params$row, _params$row2, _params$row3;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h3"
                                        }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h6",
                                            color: "secondary"
                                        }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ChildCode ? '#' + (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ChildCode) : ''));
                                    }
                                }]
                            // elements: labourElements
                        }],
                    columnSize: 12
                }
            ]
        } : null, !isMobile ? {
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 12,
            element: JCIReturnPartDetails
        } : null
        // {
        //     type: FormItemTypes.ContainerItem,
        //     name: '',
        //     columnSize: 12,
        //     spacing: 0,
        //     border: '1px solid ',
        //     borderColor: '#DEE4EB',
        //     padding: '12px',
        //     gap: '20px',
        //     borderRadius: '12px',
        //     elements: [
        //         {
        //             type: FormItemTypes.ContainerItem,
        //             name: '',
        //             columnSize: 12,
        //             spacing: 0,
        //             width: 'auto',
        //             sx: {
        //                 overflowX: 'auto',
        //                 overflowY: 'visible',
        //                 flexWrap: 'nowrap',
        //                 width: '100%',
        //                 scrollbarWidth: 'none'
        //             },
        //             position: 'static',
        //             elements: [
        //                 {
        //                     type: FormItemTypes.ContainerItem,
        //                     name: '',
        //                     columnSize: 12,
        //                     spacing: 0,
        //                     width: 'auto',
        //                     sx: {
        //                         overflowX: 'auto',
        //                         overflowY: 'visible',
        //                         flexWrap: 'nowrap',
        //                         width: '100%',
        //                         scrollbarWidth: 'none'
        //                     },
        //                     position: 'static',
        //                     elements: [
        //                         {
        //                             type: FormItemTypes.ContainerItem,
        //                             name: '',
        //                             columnSize: 0,
        //                             bgcolor: 'secondary.100',
        //                             padding: '6px',
        //                             borderRadius: '12px',
        //                             spacing: 0,
        //                             width: '480px',
        //                             border: '1px solid',
        //                             borderColor: 'secondary.200',
        //                             height: '54px',
        //                             wrap: 'nowrap',
        //                             columnGap: 2,
        //                             elements: [
        //                                 {
        //                                     type: FormItemTypes.Button,
        //                                     label: '',
        //                                     name: 'Paid',
        //                                     columnSize: 0,
        //                                     children: [
        //                                         'Paid',
        //                                         <Chip
        //                                             variant='filled'
        //                                             size='small'
        //                                             color='secondary'
        //                                             sx={{
        //                                                 fontWeight: 'medium',
        //                                                 color: 'text.primary',
        //                                             }}
        //                                             label='23,600.00'
        //                                         />
        //                                     ],
        //                                     variant: 'text',
        //                                     color: 'secondary',
        //                                     size: 'small',
        //                                     setFormState: async () => {
        //                                         const FilterPaidParts = viewInvoiceDetails?.data?.InvoiceDetails?.Parts?.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'paid')
        //                                         const FilterPaidLabour = viewInvoiceDetails?.data?.InvoiceDetails?.Labours.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'paid')
        //                                         return {
        //                                             Parts: FilterPaidParts,
        //                                             Labours: FilterPaidLabour,
        //                                             SelectedButton: 'paid'
        //                                         }
        //                                     },
        //                                     setFieldProps: (state: any) => (
        //                                         {
        //                                             type: FormItemTypes.Button,
        //                                             variant: state?.SelectedButton === 'paid' ? 'outlined' : 'text',
        //                                             color: 'secondary',
        //                                             sx: {
        //                                                 fontWeight: 'strong',
        //                                                 color: state?.SelectedButton === 'paid' ? 'text.primary' : undefined,
        //                                                 bgcolor: state?.SelectedButton === 'paid' ? 'white' : "secondary.100",
        //                                             },
        //                                         }),
        //                                 },
        //                                 {
        //                                     type: FormItemTypes.Button,
        //                                     label: '',
        //                                     name: 'Expense',
        //                                     columnSize: 0,
        //                                     children: [
        //                                         'Expense',
        //                                         <Chip
        //                                             variant='filled'
        //                                             size='small'
        //                                             color='secondary'
        //                                             sx={{
        //                                                 fontWeight: 'medium',
        //                                                 color: 'text.primary',
        //                                             }}
        //                                             label='25,000.00'
        //                                         />
        //                                     ],
        //                                     variant: 'text',
        //                                     color: 'secondary',
        //                                     size: 'small',
        //                                     fullWidth: true,
        //                                     setFormState: async () => {
        //                                         const FilterExpenseParts = viewInvoiceDetails?.data?.InvoiceDetails?.Parts?.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'expenses')
        //                                         const FilterExpenseLabour = viewInvoiceDetails?.data?.InvoiceDetails?.Labours.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'expenses')
        //                                         return {
        //                                             Parts: FilterExpenseParts,
        //                                             Labours: FilterExpenseLabour,
        //                                             SelectedButton: 'expense'
        //                                         }
        //                                     },
        //                                     setFieldProps: (state: any) => (
        //                                         {
        //                                             type: FormItemTypes.Button,
        //                                             variant: state?.SelectedButton === 'expense' ? 'outlined' : 'text',
        //                                             color: 'secondary',
        //                                             sx: {
        //                                                 fontWeight: 'strong',
        //                                                 color: state?.SelectedButton === 'expense' ? 'text.primary' : undefined,
        //                                                 bgcolor: state?.SelectedButton === 'expense' ? 'white' : "secondary.100",
        //                                             },
        //                                         }),
        //                                 },
        //                                 {
        //                                     type: FormItemTypes.Button,
        //                                     label: '',
        //                                     name: 'Claims',
        //                                     columnSize: 0,
        //                                     children: [
        //                                         'Claims',
        //                                         <Chip
        //                                             variant='filled'
        //                                             size='small'
        //                                             color='secondary'
        //                                             sx={{
        //                                                 fontWeight: 'medium',
        //                                                 color: 'text.primary',
        //                                             }}
        //                                             label='28,000.00'
        //                                         />
        //                                     ],
        //                                     variant: 'text',
        //                                     color: 'secondary',
        //                                     size: 'small',
        //                                     fullWidth: true,
        //                                     setFormState: async () => {
        //                                         const FilterClaimsParts = viewInvoiceDetails?.data?.InvoiceDetails?.Parts?.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'generate claims')
        //                                         const FilterClaimsLabour = viewInvoiceDetails?.data?.InvoiceDetails?.Labours.filter((item: any) => item?.PostingTypeName?.toLowerCase() === 'generate claims')
        //                                         return {
        //                                             Parts: FilterClaimsParts,
        //                                             Labours: FilterClaimsLabour,
        //                                             SelectedButton: 'claims'
        //                                         }
        //                                     },
        //                                     setFieldProps: (state: any) => (
        //                                         {
        //                                             type: FormItemTypes.Button,
        //                                             variant: state?.SelectedButton === 'claims' ? 'outlined' : 'text',
        //                                             color: 'secondary',
        //                                             sx: {
        //                                                 fontWeight: 'strong',
        //                                                 color: state?.SelectedButton === 'claims' ? 'text.primary' : undefined,
        //                                                 bgcolor: state?.SelectedButton === 'claims' ? 'white' : "secondary.100",
        //                                             },
        //                                         }),
        //                                 },
        //                             ],
        //                         },
        //                     ]
        //                 },
        //             ]
        //         },
        //         {
        //             type: FormItemTypes.Custom,
        //             name: 'Parts',
        //             // element: PartInvoiceDetails,
        //             columnSize: 12,
        //         },
        //         {
        //             type: FormItemTypes.Custom,
        //             name: 'Labours',
        //             // element: LabourInvoiceDetails,
        //             columnSize: 12,
        //         }
        //     ]
        // }
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: '60px',
                lg: '60px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: '20px'
        },
        formData: invoiceDetails
        // getFormAPI={getViewInvoiceDetails}
        // getKey={JobCardInvoicesKeys.ViewInvoiceDetails}
        ,
        getRequest: {
            id: data === null || data === void 0 ? void 0 : data.id,
            CustomerId: data === null || data === void 0 ? void 0 : data.CustomerId
        }
    })));
};
export default InvoiceDetailsView;
